const page       = require('../../../../../components/page/page')
const clientPurchaseDt = require('./clientPurchase-dt')

import clientPurchasePage       from "./clientPurchase-page.html";


/****************ELEMENTS*****************/
var HTMLwasSelected  = false

//insert the page  on the body
function HTMLselect(detail){ 
	
	HTMLwasSelected = true

	//load the page to the index
   const body = document.body
   body.insertAdjacentHTML("beforeend", clientPurchasePage)

   clientPurchaseDt.start({"dest":"clientPurchase", "elem":"dt", "act":"select", "entity":"clientPurchase"})

}/*init*/

/****************ELEMENTS*****************/
export function start(detail){ 
  
   if(!HTMLwasSelected) {HTMLselect(detail)}
	obj[detail.act].start(detail)
}

const obj = {
   
      show:  { start: (detail)=>{  page.start(detail)     }},

}/**/


